import { render, staticRenderFns } from "./edit-account.vue?vue&type=template&id=435f0d1a&scoped=true&"
import script from "./edit-account.vue?vue&type=script&lang=js&"
export * from "./edit-account.vue?vue&type=script&lang=js&"
import style0 from "./edit-account.vue?vue&type=style&index=0&id=435f0d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435f0d1a",
  null
  
)

export default component.exports